<template>
    <div class="page newpage">
		<el-tabs v-model="tabType" type="card">
			<el-tab-pane label="京东物流" name="1"></el-tab-pane>
			<el-tab-pane label="快递100（查货）" name="2"></el-tab-pane>
		  </el-tabs>
		<div v-if="tabType==1">
			<el-form label-position="right" label-width="120px" :model="formData" class="pr_20">
			  <el-form-item label="接口适用：">
			    适用于京东物流自研商家<br/>
			    (①已经与京东物流签约;②同时，必须有月结编码/客户编码/服务编码之一(010K等或EBU开头))<br/>
				<a href="http://open.jdl.com" target="_blank">京东物流开放平台:http://open.jdl.com</a>
			  </el-form-item>
			  <el-form-item label="appKey：">
			    <el-input v-model="formData.jd_app_key" style="width: 500px;"></el-input>
			  </el-form-item>
			  <el-form-item label="appSceret：">
			    <el-input v-model="formData.jd_app_secret" style="width: 500px;"></el-input>
			  </el-form-item>
			  <el-form-item label="token：">
				  <el-input v-model="formData.jd_access_token" style="width: 500px;"></el-input>
			  </el-form-item>
			  <el-form-item label="客户编码：">
			    <!-- <div class="_flex">
					<el-input v-model="formData.jd_customer_code"></el-input>
					<div class=" ml_10 lh_30 c9" >(月结编码/客户编码/服务编码之一(010K等或EBU开头))</div>
				</div> -->
                <el-table :data="formData.jd_accounts" style="width: 100%;" :header-cell-style="{ background:'#f5f5f5'}">
                    <el-table-column prop="name" label="名称" width="150">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.name" placeholder="" clearable></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="customer_code" label="客户编码" width="180">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.customer_code" placeholder="" clearable></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="business_unit_code" label="事业部编码" width="200">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.business_unit_code" placeholder="" clearable></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="sender_name" label="寄件人姓名" width="150">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.sender_name" placeholder="" clearable></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="sender_phone" label="寄件人电话" width="180">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.sender_phone" placeholder="" clearable></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="sender_full_address" label="寄件地址" width="380">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.sender_full_address" placeholder="" clearable></el-input>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="sender_full_address" label="适用部门" width="200">
                        <template slot-scope="scope">
                            <el-cascader v-model="scope.row.sender_depart" clearable :options="departArr" :props="{value:'id',label:'name',checkStrictly:true,multiple: true}" size="small" placeholder=" "></el-cascader>
                        </template>
                    </el-table-column> -->
                    <el-table-column label="操作" width="100" :render-header="renderHeaderPopads" >
                        <template slot-scope="scope">
                            <el-button type="danger" size="mini" @click="delPopads(scope.$index)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
			  </el-form-item>
			  <!-- <el-form-item label="主产品：">
				    <el-radio-group v-model="formData.jd_product_code">
				      <el-radio v-for="item in product_code_arr" :key="item.code" :label="item.code">{{item.name}}</el-radio>
				    </el-radio-group>
			  </el-form-item> -->
			  <el-form-item label="增值服务：">
                    <el-checkbox-group v-model="formData.jd_added_product_code">
                        <el-checkbox v-for="item in added_product_code_arr" :key="item.code" :label="item.code">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
			  </el-form-item>
			  <el-form-item label="付款方式：">
				  <el-radio-group v-model="formData.pay_type">
				      <el-radio :label="1">月结</el-radio>
				    </el-radio-group>
			  </el-form-item>
			  <!-- <el-form-item label="统一寄件人：">
			    <div class="_flex">
					<el-input v-model="formData.jd_sender_name" style="width: 300px;margin-right: 10px;" placeholder="姓名"></el-input>
					<el-input v-model="formData.jd_sender_phone" style="width: 300px;margin-right: 10px;" placeholder="手机号"></el-input>
					<el-input v-model="formData.jd_sender_full_address" style="width: 600px;" placeholder="省/市/区/详细地址"></el-input>
				</div>
			  </el-form-item> -->
			  <div class="ml_200 mt_50">
					<el-button type="primary" v-permit="'/admin/setting/jd'" @click="submitJd">保存</el-button>
			  </div>
			</el-form>
		</div>
		<div class="w_50" v-if="tabType==2">
			<el-form label-position="right" label-width="150px" :model="formData" class="pr_20">
			  <el-form-item label="接口适用：">
				  适用于大部份物流快递的进度查询。接口查询资费标准以快递100官方政策为准。<br/>
				  注册账户并预存款，金额不足会导致查询失败。<br/>
				  注册地址:<a class="blue" href="">httos://anikuaidi100.com/register</a>
			  </el-form-item>
			  <el-form-item label="快递100KEY：">
			    <el-input v-model="formData.kuaidi100_key"></el-input>
			  </el-form-item>
			  <el-form-item label="快递100 Customer：">
			    <el-input v-model="formData.kuaidi100_customer"></el-input>
			  </el-form-item>
			  <div class="ml_200 mt_50">
					<el-button type="primary" v-permit="'/admin/setting/kuaidi100'" @click="submitKuaidi100">保存</el-button>
			  </div>
			</el-form>
		</div>
		
    </div>
</template>
<script>
import { setJd, setKuaidi100, DepartmentLists } from "@/request/apis.js"
export default{
    data(){
        return {
			tabType : '1',
			name:'',
            list : [{id:1,name:'张三是'}],
			show : false,
			represShow : false,
			formData : {
                pay_type: 1,
				jd_app_key : '',
                jd_app_secret : '',
                jd_access_token : '',
                jd_accounts: [],
                jd_customer_code: '',
                jd_customer_code4: '',
                jd_business_unit_code: '',
                jd_product_code : '',
                jd_added_product_code : [],
                jd_sender_name : '',
                jd_sender_phone : '',
                jd_sender_full_address : '',
			},
            product_code_arr: [],
            added_product_code_arr: [],
            popads: {name: '', customer_code: '', business_unit_code: ''},
            departArr: [],
        }
    },
	mounted() {
		this.init()
        this.getSetJd();
        this.getSetKuaidi100();
        this.getDepartmentLists(true);
	},
	methods:{
		init(){
			
		},
        async getSetJd(){
            let res = await setJd('get');
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.formData = {...this.formData, ...res.data};
            this.product_code_arr = res.data.product_code;
            this.added_product_code_arr = res.data.added_product_code;
        },
        async getSetKuaidi100(){
            let res = await setKuaidi100('get');
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.formData = {...this.formData, ...res.data};
        },
        async submitJd(){
            let res = await setJd('post', this.formData);
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
        },
        async submitKuaidi100(){
            let res = await setKuaidi100('post', this.formData);
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
        },

        renderHeaderPopads(h) {
            return(
                <div>
                    <el-button type="success" size='mini' onClick={()=>this.addPopads()}>增加</el-button>
                </div>
            )
        },
        addPopads(){
            this.formData.jd_accounts.push({...this.popads})
        },
        delPopads(index){
            this.formData.jd_accounts.splice(index, 1);
        },

        async getDepartmentLists(query){
            if (!query || this.departArr.length) {
                return false;
            }
            var res = await DepartmentLists();
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.departArr = res.data;
        },
	}
}
</script>

<style  scoped>
</style> 